// mui components
import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material/styles';

const PurpleButton = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  height: '48px',
  backgroundColor: theme.colors.main.purple,
  ...theme.fontStyles.body,
  color: theme.colors.main.white,
  textTransform: 'unset',
  '&:hover': {
    backgroundColor: theme.colors.main.purpleDark,
  },
  '&.Mui-disabled': {
    color: 'rgba(255, 255, 255, 1)',
    // theme.colors.main.purpleDark (#5800af) at 50% alpha
    backgroundColor: 'rgba(88, 0, 175, 0.5)',
  },
})) as typeof LoadingButton;

export default PurpleButton;
